function normalizeRules (rules) {
  if (!rules) return []
  return Array.isArray(rules) ? rules : [rules]
}

function getTargetItems (question, rule) {
  const target = rule.target || 'questions'
  const items = question && question[target]

  return Array.isArray(items) ? items : []
}

function getDefaultValue (item, rule) {
  if (rule.sourceField) {
    return item && item[rule.sourceField]
  }

  if (rule.defaultOptionMain && rule.optionsField) {
    const options = item && item[rule.optionsField]
    const defaultOption =
      Array.isArray(options) &&
      options.find((option) => option.main === rule.defaultOptionMain)

    if (defaultOption) {
      return defaultOption.main
    }
  }

  return rule.value
}

function applyQuestionFinalAnswerDefaults (question) {
  normalizeRules(question && question.finalAnswerDefaults).forEach((rule) => {
    const answerField = rule.answerField || 'answer'

    getTargetItems(question, rule).forEach((item) => {
      if (
        rule.whenItemHiddenByDisabilityExtremity &&
        !item.hiddenByDisabilityExtremity
      ) {
        return
      }

      if (item[answerField] && !rule.overwrite) {
        return
      }

      const defaultValue = getDefaultValue(item, rule)
      if (defaultValue !== undefined && defaultValue !== null) {
        item[answerField] = defaultValue
      }
    })
  })
}

export function applyFinalAnswerDefaults (questions) {
  (questions || []).forEach(applyQuestionFinalAnswerDefaults)

  return questions
}
